/**
 * single-pdp-buybox.js
 *
 * Companion to snippets/buy-box-single-pdp.liquid (product.single-pdp).
 * Single-flavor buy box: the customer picks one flavor, and the
 * 1 / 2 / 3 pack tiles set the quantity of that flavor.
 *
 * Do NOT load this on the same page as bundle-subscription.js.
 */

(function () {
  'use strict';

  var FREE_SHIPPING_HTML =
    '<span>' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M11.3333 13.3333C12.0697 13.3333 12.6667 12.7363 12.6667 12C12.6667 11.2636 12.0697 10.6666 11.3333 10.6666C10.597 10.6666 10.597 13.3333 11.3333 13.3333Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M4.66536 13.3333C5.40174 13.3333 5.9987 12.7363 5.9987 12C5.9987 11.2636 5.40174 10.6666 4.66536 10.6666C3.92898 10.6666 3.33203 11.2636 3.33203 12C3.33203 12.7363 3.92898 13.3333 4.66536 13.3333Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M3.33203 11.9816L2.00612 11.9938C1.63554 11.9972 1.33332 11.6977 1.33332 11.3272V9.99996M5.9987 12H9.9987M1.33203 2.66663H8.66536C9.03356 2.66663 9.33203 2.96511 9.33203 3.33329V6.66663C9.33203 7.03483 9.6305 7.33329 9.9987 7.33329H14.6654V11.3333C14.6654 11.7015 14.3669 12 13.9987 12H12.6654" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M1.33203 5.33337H5.33203M1.33203 7.33337H3.9987" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M9.33203 4L11.9104 4.00001C12.3788 4.00001 12.8128 4.24575 13.0538 4.64735L14.6654 7.33333" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      ' +Free Shipping' +
    '</span>';

  function init() {
    var buybox = document.querySelector('[data-single-pdp-buybox]');
    if (!buybox) return;

    var atcBtn             = buybox.querySelector('[data-add-to-cart]');
    var selectedVariantEl  = buybox.querySelector('[data-selected-variant-id]');
    var purchaseOptionsEl  = buybox.querySelector('[data-purchase-options]');
    var subPriceEl         = buybox.querySelector('[data-sub-price]');
    var comparePriceEl     = buybox.querySelector('[data-compare-price]');
    var discountBadgeEl    = buybox.querySelector('[data-discount-badge]');
    var onetimePriceEl     = buybox.querySelector('[data-onetime-price]');
    var firstMonthPerkEl   = buybox.querySelector('[data-first-month-perk]');
    var subscribeExpand    = buybox.querySelector('.purchase-option__subscribe-expand');
    var atcText            = buybox.getAttribute('data-atc-text') || 'Add to Cart';
    var busy               = false;

    // ── Helpers ──────────────────────────────────────────────────

    function getPack() {
      var checked = buybox.querySelector('[name="pack-count"]:checked');
      return checked ? String(checked.value) : '1';
    }

    function isSubscribe() {
      var sub = buybox.querySelector('[data-purchase-type][value="subscribe"]');
      return !!(sub && sub.checked);
    }

    function currentPriceText() {
      var el = isSubscribe() ? subPriceEl : onetimePriceEl;
      return el ? el.textContent.trim() : '';
    }

    // ── Pricing (all totals are pre-rendered in Liquid) ──────────

    function refreshPricing() {
      if (!purchaseOptionsEl) return;
      var pack = getPack();

      var subTotal     = purchaseOptionsEl.getAttribute('data-sub-total-' + pack);
      var compareTotal = purchaseOptionsEl.getAttribute('data-compare-total-' + pack);
      var onetimeTotal = purchaseOptionsEl.getAttribute('data-onetime-total-' + pack);
      var discountPct  = purchaseOptionsEl.getAttribute('data-discount-pct-' + pack);

      if (subPriceEl && subTotal) subPriceEl.textContent = subTotal;
      if (comparePriceEl && compareTotal) comparePriceEl.textContent = compareTotal;
      if (onetimePriceEl && onetimeTotal) onetimePriceEl.textContent = onetimeTotal;
      if (discountBadgeEl && discountPct) discountBadgeEl.textContent = 'Save ' + discountPct.trim() + '%';

      if (firstMonthPerkEl) {
        var perk = firstMonthPerkEl.getAttribute('data-perk-' + pack);
        if (perk) firstMonthPerkEl.textContent = perk;
      }
    }

    /** Per-bar prices on the pack tiles follow subscribe vs one-time */
    function refreshPerBar() {
      var useSub = buybox.getAttribute('data-has-selling-plans') === 'true' && isSubscribe();

      buybox.querySelectorAll('.pack-selector__per-bar-line').forEach(function (row) {
        var grossEl = row.querySelector('.pack-selector__per-bar-gross');
        var netEl   = row.querySelector('.pack-selector__per-bar');
        if (!netEl) return;

        var text = useSub ? netEl.dataset.perBarSubscribe : netEl.dataset.perBarOnetime;
        if (text) netEl.textContent = text;

        if (!grossEl) return;
        var gross = parseInt(grossEl.getAttribute('data-gross-cents'), 10) || 0;
        var net   = parseInt(netEl.getAttribute(useSub ? 'data-sub-cents' : 'data-ot-cents'), 10) || 0;
        if (gross > net) grossEl.removeAttribute('hidden');
        else grossEl.setAttribute('hidden', '');
      });
    }

    /** ATC label + any .text-scheme-text-runJS price blocks */
    function refreshLabels() {
      if (busy) return;
      var price = currentPriceText();
      if (!price) return;

      if (atcBtn) atcBtn.textContent = atcText + ' - ' + price;

      document.querySelectorAll('.text-scheme-text-runJS').forEach(function (el) {
        el.innerHTML = price + ' ' + FREE_SHIPPING_HTML;
      });
    }

    function refreshPurchaseView() {
      var sub = isSubscribe();
      if (subscribeExpand) {
        subscribeExpand.setAttribute('aria-hidden', String(!sub));
        if (sub) subscribeExpand.removeAttribute('inert');
        else subscribeExpand.setAttribute('inert', '');
      }
      refreshPricing();
      refreshPerBar();
      refreshLabels();
    }

    // ── Events ───────────────────────────────────────────────────

    buybox.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;

      if (t.matches('[data-variant-radio]') && selectedVariantEl) {
        selectedVariantEl.value = t.value;
      }

      if (t.name === 'pack-count' || t.matches('[data-purchase-type]')) {
        refreshPurchaseView();
      }
    });

    // ── Add to cart ──────────────────────────────────────────────

    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = selectedVariantEl ? parseInt(selectedVariantEl.value, 10) : NaN;
        if (!variantId) return;

        var item = { id: variantId, quantity: parseInt(getPack(), 10) || 1 };

        if (isSubscribe()) {
          var freq   = buybox.querySelector('[data-frequency-select]');
          var planId = freq ? parseInt(freq.value, 10) : NaN;
          if (planId > 0) item.selling_plan = planId;
        }

        busy = true;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error(data.description || ('Cart error ' + res.status));
              });
            }
            return res.json();
          })
          .then(function () {
            atcBtn.textContent = 'Added!';
            document.dispatchEvent(new CustomEvent('theme:update:cart', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', { bubbles: true }));
            setTimeout(resetButton, 2000);
          })
          .catch(function (err) {
            console.error('[single-pdp] Cart add failed:', err);
            atcBtn.textContent = 'Error — try again';
            setTimeout(resetButton, 2500);
          });
      });
    }

    function resetButton() {
      busy = false;
      atcBtn.disabled = false;
      refreshLabels();
    }

    // ── ?variant=ID preselect (keeps the default pack tier) ──────

    function applyVariantFromUrl() {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (!id) return;
      var radio = buybox.querySelector('[data-variant-radio][value="' + CSS.escape(id) + '"]');
      if (!radio || radio.disabled) return;
      radio.checked = true;
      if (selectedVariantEl) selectedVariantEl.value = radio.value;
    }

    applyVariantFromUrl();
    refreshPurchaseView();
  }

  // ── Page extras carried over from bundle-subscription.js (null-safe) ──

  function initStockInfo() {
    document.addEventListener('variant:change', function (event) {
      var stockEl = document.querySelector('.product-stock-info');
      var variant = event.detail && event.detail.variant;
      if (!stockEl || !variant) return;

      var qty = variant.inventory_quantity;
      if (qty > 10) {
        stockEl.innerHTML = '<span class="stock in-stock">✅ In Stock</span>';
      } else if (qty > 0) {
        stockEl.innerHTML = '<span class="stock low-stock">⚠️ Low Stock (Only ' + qty + ' left)</span>';
      } else {
        stockEl.innerHTML = '<span class="stock out-stock">❌ Out of Stock</span>';
      }
    });
  }

  function initDeliveryDate() {
    var el = document.getElementById('delivery-date');
    if (!el) return;

    function addBusinessDays(date, days) {
      var result = new Date(date);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        var day = result.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return result;
    }

    var opts  = { day: 'numeric', month: 'short' };
    var today = new Date();
    el.textContent =
      addBusinessDays(today, 4).toLocaleDateString('en-US', opts) + ' - ' +
      addBusinessDays(today, 6).toLocaleDateString('en-US', opts);
  }

  function start() {
    init();
    initStockInfo();
    initDeliveryDate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
